import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select, {components} from "react-select";
import translate from '../../services/translation';
import ReactSelectAdapter from "./ReactSelectAdapter";
import SelectIcon from "../Favourites/SelectIcon";

export default class SeasonSingleSelector extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        onChange: PropTypes.func,
        resetFunction: PropTypes.func,
        isMulti: PropTypes.bool,
        hasSpecialIcon: PropTypes.bool,
        years: PropTypes.array,
        timeOfYear: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        selectedYear: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
    };

    handleUpdateEvent = (updateEvent) => {
        const season = {
            target: {
                name: 'year',
                value: updateEvent.year,
                timeOfYear: updateEvent.timeOfYear
            }
        };

        this.props.onChange(season);
    };

    render() {
        const {defaultOptionLabel, years, timeOfYear, selectedYear} = this.props;

        const castOptions = years ? years.map(option => {
            return {year: option.year, value: option.key, label: option.title, timeOfYear: option.timeOfYear};
        }) : [];

        const filterSelectedYear = selectedYear !== 0 ? castOptions.find(option => option.year === selectedYear && option.timeOfYear === timeOfYear) : selectedYear;

        const DropdownIndicator = props => {
            return (
                <components.DropdownIndicator {...props}>
                    {this.props.hasSpecialIcon?(<SelectIcon/>):null}
                </components.DropdownIndicator>
            );
        };

        return (
            <div className="selectCustom">
                <Select
                    value={filterSelectedYear}
                    onChange={this.handleUpdateEvent}
                    options={castOptions}
                    isClearable={false}
                    isSearchable={ false }
                    placeholder={defaultOptionLabel}
                    styles={ReactSelectAdapter.customStyles}
                    classNamePrefix={'select-basic'}
                    noOptionsMessage={() => translate('planner_list.no_options')}
                    components={{DropdownIndicator}}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Planner/SeasonSingleSelector.js